export enum ContentLibraryFiltersEnum {
    NAME = 'NAME',
    UPLOADED_DATE = 'UPLOADED_DATE',
    FILE_SIZE = 'FILE_SIZE',
    MIME_TYPE = 'MIME_TYPE',
    UPLOADED_BY = 'UPLOADED_BY',
    APPROVED_BY = 'APPROVED_BY'
}
